/* eslint-disable import/prefer-default-export */
// Styles that are more specific than the element level, but that we still want
// to reuse across multiple components. Basically things that would be regular
// CSS classes in a non-JS-based theme.
import { css } from "@emotion/react"
import { fonts, colors, weights, mediaQueries } from "./css-utils"

// Containers
const contWidths = [680, 820, 1020, 1120, 1220]
const contLabels = [`min`, `textOnly`, `medium`, `large`, `max`]

export const contValues = contWidths.reduce((acc, value, i) => {
  acc[contLabels[i]] = `${value}px`
  return acc
}, {})

export const container = contWidths.reduce((acc, w, i) => {
  acc[contLabels[i]] = css`
    width: ${w}px;
    max-width: 100%;
    margin: 0 auto;
    padding-left: 20px;
    padding-right: 20px;
  `
  return acc
}, {})

export const btnStyles = css`
  position: relative;
  padding: 0;
  border: none;
  outline: none;
  font-family: ${fonts.sans};
  font-weight: ${weights.bold};
  font-size: 15px;
  line-height: 1.2;
  letter-spacing: 2px;
  text-transform: uppercase;
  background: transparent;
  color: ${colors.brBlue3};
  cursor: pointer;

  span {
    display: block;
    position: relative;
    padding: 17px 28px;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-image: linear-gradient(
      to bottom,
      ${colors.brBlue3},
      ${colors.brBlue3} 50%,
      ${colors.hmLight} 50%
    );
    background-size: 100% 200%;
    background-position: top;
    transition: all 0.3s ease;
  }
  &::before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    transition: 0.3s ease height;
    background: ${colors.brBlue3};
  }
  &:hover,
  &:focus {
    transition: all 0.3s ease;

    span {
      background-position: bottom;
    }

    &::before {
      height: 100%;
    }
  }
`

export const btnStylesInverted = css`
  position: relative;
  padding: 0;
  border: none;
  outline: none;
  font-family: ${fonts.sans};
  font-weight: ${weights.bold};
  font-size: 15px;
  line-height: 1.2;
  letter-spacing: 2px;
  text-transform: uppercase;
  background: transparent;
  color: ${colors.hmLight};
  cursor: pointer;

  span {
    display: block;
    position: relative;
    padding: 17px 28px;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-image: linear-gradient(
      to bottom,
      ${colors.hmLight},
      ${colors.hmLight} 50%,
      ${colors.brBlue3} 50%
    );
    background-size: 100% 200%;
    background-position: top;
    transition: all 0.3s ease;
  }
  &::before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    transition: 0.3s ease height;
    background: ${colors.hmLight};
  }
  &:hover,
  &:focus {
    transition: all 0.3s ease;

    span {
      background-position: bottom;
    }

    &::before {
      height: 100%;
    }
  }
`
// Heading modifications
export const h1L = css`
  font-size: 39px;
  font-weight: ${weights.semibold};
  line-height: 1.23;
  letter-spacing: -0.45px;

  ${mediaQueries.phoneLarge} {
    font-size: 72px;
    line-height: 1.16;
    letter-spacing: 0;
  }
`

export const smSectionHead = css`
  margin-bottom: 0;
  font-size: 21px;
  font-weight: ${weights.light};
  letter-spacing: 0.23px;
  line-height: 3.62;

  ${mediaQueries.phoneLarge} {
    margin-bottom: 30px;
    font-size: 36px;
    line-height: 2;
    letter-spacing: 0.4px;
  }
`

export const smSectionHeadMainPage = css`
  margin-bottom: 0;
  font-size: 21px;
  font-weight: ${weights.light};
  letter-spacing: 0.23px;
  line-height: 3.62;

  ${mediaQueries.phoneLarge} {
    margin-bottom: 30px;
    margin-top: 30px;
    font-size: 36px;
    line-height: 2;
    letter-spacing: 0.4px;
  }
`

export const contentH2 = css`
  margin-top: 25px;
  margin-bottom: 10px;
  font-family: ${fonts.sans};
  font-size: 21px;
  font-weight: ${weights.bold};
  line-height: 1.4;
`

export const contentHeadings = css`
  font-family: ${fonts.sans};
  font-size: 16px;
  font-weight: ${weights.bold};
  letter-spacing: 0.2px;
  line-height: 1.69;
  margin-bottom: 30px;
`

export const pLight = css`
   {
    font-family: ${fonts.sans};
    font-size: 16px;
    font-weight: ${weights.light};
    letter-spacing: 0.2px;
    line-height: 1.69;
    text-align: center;
  }
`